
import { Component, OnInit } from '@angular/core';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscTableViewComponent } from '../usc-table-view/usc-table-view.component';

@Component({
    selector: 'sn-usc-mobile-action-plans',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['./usc-mobile-action-plans.component.css', '../usc-table-view/usc-table-view.component.css']
})    


export class UscMobileActionPlansComponent extends UscTableViewComponent {

    previous_action_plan_loaded: boolean = false;

    ngOnInit() {
        this.isPreviousMonthEnabled = false;
        this.enabled_include_todays_sales = false;
        this.enabled_gross_adds_accs_buttons = false;
        super.ngOnInit();
    }

    getDetailItems(init_filter_fields:boolean) {
        if (this.view == this.uscStoreService.view_p2w_previous_action_plans) {
            this.uscStoreService.previousActionPlansLoaded.subscribe(bLoaded => {
                if (bLoaded && !this.previous_action_plan_loaded) {
                    this.previous_action_plan_loaded = bLoaded;
                    var detail_items = this.uscStoreService.getAllPreviousActionPlans(this.current_user);
                    this.processDetailItems(detail_items, init_filter_fields);
                }
            });
        } else {
            var action_plan_subject = "";
            if (this.view == this.uscStoreService.view_p2w_team_this_action_plans) {
                action_plan_subject = this.uscStoreService.getThisMonthActionPlanSubject();
            } else if (this.view == this.uscStoreService.view_p2w_team_next_action_plans) {
                action_plan_subject = this.uscStoreService.getNextMonthActionPlanSubject();
            }
            this.uscStoreService.getTeamActionPlans(action_plan_subject).subscribe(result => {
                var detail_items = result.items;
                this.processDetailItems(detail_items, init_filter_fields);
            });
        }
        return null; 
    }

    initPageFilterFieldSelections() {
        var scope = this.uscStoreService.getCurrentDetailResultScope();
        var current_user_scorecard = this.uscStoreService.isLeader() ? this.detail_items.find(i => i[scope.scope_type] == scope.scope_value) : this.detail_items.find(i => i.CREATOR_ID == this.current_user.username);       
        // HACK: initialize page filters based on user's scope_type
        //       agency -> select agency only
        //       region -> select region only
        //       territory => select region and territory
        //       area => select region, territory, and area
        //       store => select region, territory, area, and store
        if (this.uscStoreService.isLeader()) {
            current_user_scorecard = JSON.parse(JSON.stringify(current_user_scorecard));
            switch (scope.scope_type) {
                case "agency": current_user_scorecard.store = null; break;
                case "region": current_user_scorecard.territory = null; // fall through
                case "territory": current_user_scorecard.area = null; // fall through
                case "area": current_user_scorecard.store = null; // fall through
                    break;
            }
        }
        // NOTE: pageFilterField is also a columnField
        this.pageFilterFields.forEach(cf => {
            if (cf.key != "cs_subject") {
                if (current_user_scorecard) {
                    if (cf.current_filtered_value == null && current_user_scorecard[cf.key]) cf.current_filtered_value = current_user_scorecard[cf.key];
                }
            } else if (!cf.allow_all_as_filter_value && cf.current_filtered_value == null) {
                cf.current_filtered_value = cf.filter_data[0].value;
            }
        })
    }

    onFocusOut(action_plan, field) {
        var cs_days_worked_offset = action_plan.cs_days_worked_offset ? parseInt(action_plan.cs_days_worked_offset) : 0;
        var daily_goals_submitted = action_plan.daily_goals_submitted ? parseInt(action_plan.daily_goals_submitted) : 0;
        var previous_days_worked = daily_goals_submitted + cs_days_worked_offset;
        var days_worked = parseInt(action_plan.days_worked);
        if (field.key == "days_worked" && days_worked >= action_plan.daily_goals_submitted && days_worked <= action_plan.cs_days_scheduled) {
            if (days_worked == previous_days_worked) return;
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Updating Days Worked..."});
            var data = { "daily_goals_submitted": action_plan.daily_goals_submitted, "days_worked": days_worked };
            this.apiService.processActionOnViewItem(this.view, action_plan.view_ID, this.uscStoreService.action_update_days_worked, data).subscribe( 
                result => {
                    action_plan.cs_days_worked_offset = action_plan.days_worked - daily_goals_submitted;
                    dlg.dismiss();
                }
            )
        } else {
            action_plan.days_worked = cs_days_worked_offset + daily_goals_submitted;
            var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, {msgList: ["Invalid Input.  Days Worked must be greater than Daily Goal Submitted and less than or equal to Days Scheduled."]});
            modalRef.result.then((result) => { }, (reason) => {  })
        }
    }

    getFieldValue(detail_item, field): any {
        if (detail_item && field) {
            var field_value = detail_item[field.key];
            switch (field.key) {
                case 'cs_approver': 
                    if (detail_item.cs_status != this.uscStoreService.action_plan_status_approved) field_value = "";
                    break;
                case 'cs_approval_requested_on':
                case 'cs_approval_received_on':
                    field_value = this.calendarService.getDateText(new Date(field_value), 'yyyy-MM-dd');
                    break;
                case "cs_p2w_postpaid":
                case "cs_p2w_other":
                case "cs_p2w_bir":
                case "cs_p2w_accessories_revenue":
                case "cs_p2w_other_revenue":
                case "cs_p2w_upgrades":
                case "cs_p2w_high_acc":
                case "cs_p2w_device_trade_ins":
                case "days_worked":
                    if (detail_item.ur_title == 'Store' || detail_item.ur_title == 'Assistant Manager') return "N/A";  // store action plan 
                    break;
                case "":

                    break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    getFieldFilterDisplay(item, field): any {
        if (item && field) {
            var field_display = this.getFieldValue(item, field);
            switch (field.key) {
                case "cs_subject":
                    field_display = this.uscStoreService.convertPlanMonth(field_display);
                    break;
            }

            return field_display;
        }
        return null;
    }

    getFilteredValue(field) {
        if (field.key == 'cs_subject') return this.uscStoreService.convertPlanMonth(field.current_filtered_value);
        return super.getFilteredValue(field);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-mobile-action-plans/usc-mobile-action-plans.component.ts